import React, {Component} from 'react';

class PageHeader extends Component {
    render() {
        return (
            <div className="row wrapper border-bottom white-bg page-heading" style={this.props.availableAsSteward ? {background: '#ffbb73'} : this.props.availableForBottleDeposit ? {background: '#c6caff'} : {}}>
                <div className="col-lg-12">
                    {this.props.loading ? (
                        <div className="pull-right sk-spinner sk-spinner-rotating-plane" style={{marginTop: 23}}/>
                    ): null}
                    <h2>
                        {this.props.title}
                    </h2>
                    <p>
                        {this.props.subtitle}
                    </p>
                </div>
            </div>
        )
    }
}

export default PageHeader;